import { PublicValidatedUser } from "../../../../shared/types";
import { useApp } from "../../../hooks/use-app/useApp";
import { useLocalization } from "../../../hooks/use-localization/useLocalization";
import { Providers } from "../../../components/providers/providers";
import { Form } from "../../../components/form/form";

export const Validate: React.FC<{
  onValidate: (user: PublicValidatedUser) => any;
}> = ({ onValidate: onValidateUser }) => {
  const { localize } = useLocalization();
  const app = useApp();
  const alternativeProviders = app.providers.filter((p) => p.slug !== "email");

  return (
    <>
      <Form
        action="/check-email"
        method="POST"
        actionLabel={localize("next")}
        onSuccess={onValidateUser}
        errorMap={{
          400: localize("error:userNotFound"),
          429: localize("error:rateLimitExceeded"),
        }}
      >
        <label>
          {localize("email")}
          <input
            type="email"
            name="email"
            placeholder="min@e-post.no"
            required
          />
        </label>
      </Form>
      <Providers hasEmailProvider providers={alternativeProviders} />
    </>
  );
};
